import { EPublishTermsStatus, IPublishTermsServices, IPublishTermsState, IPublication } from './types';

const publication: IPublication = {
  period: null,
};

export const defaultState: IPublishTermsState = {
  isNewPublishTermsEnabled: false,
  status: EPublishTermsStatus.initial,
  services: {} as IPublishTermsServices,
  serviceIds: [],
  selectedServiceId: null,
  promotionServiceId: null,
  message: null,
  error: null,
  isMultipostingAvailable: false,
  multipostingABGroup: null,
  packages: {},
  packageIds: [],
  selectedPackageId: null,
  periodsByService: {},
  selectedPeriodId: null,
  selectedPlacingType: null,
  publication,
  withoutMinimalBet: false,
  withoutPromotion: false,
  isServicesEnabled: true,
  moneySource: null,
  diffPricing: {
    iterationId: null,
    granuleGuid: null,
  },
  highDemandCoefficient: null,
};
